export default __webpack_public_path__ + "static/media/Spotify-Icon-Black-Logo.6e99526c.svg";